import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import Card from "../../../common/Card"
import PracticeItem from "./PracticeItem"
import AICAStatus from "./AICAStatus"
import { changeWordingForWC } from "../../../../lib/misc"

import classes from './Practices.module.css'
import { checkIfLopIsRequired } from "../../../../lib/script"
import { formatCurrency } from "../../../../lib/script"
import { isTestCaseForLien } from "../../../../lib/systemData"
import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions"
import { isManagingAttorney } from "../../../../lib/primaryItemScripts"

const PracticeTable = () => {
    let userPermissionViewAmounts = useUserTabEditPermissionDisabled('practice_amounts_view')
    let userPermissionEditStatus = useUserTabEditPermissionDisabled('practice_patient_status_edit')
    const [managingAttorney, setManagingAttorney] = useState(null)
    const activeCase = useSelector(state => state.case.activeCase) 

    const practices = Array.isArray(activeCase?.practices) ? activeCase.practices : []
    const totals = practices.reduce((acc, item) => {
        const totalCharges = Number(item?.total_charges) || 0
        const balance = Number(item?.balance) || 0

        return {
            totalCharges: acc.totalCharges + totalCharges,
            totalPracticeBalance: acc.totalPracticeBalance + balance,
        }
    }, {
        totalCharges: 0,
        totalPracticeBalance: 0,
    })

    useEffect(() => {
        if (activeCase && activeCase.attorneys && activeCase.attorneys.length > 0) {
  
            let managingAtty = activeCase.attorneys.find(item => item.is_managing_attorney)
            if (managingAtty) {
                setManagingAttorney(managingAtty)
            } else {
                setManagingAttorney(null)
            }            
        } 
    }, [activeCase])

    return <>
        {activeCase && <>
            <Card border={0}>

                <div className={classes.overflow_container}>
                    <table className="table-border-radius-8">
                        <thead>
                            <tr>
                                <th>Practice Type</th>
                                <th>Chart #</th>
                                {userPermissionViewAmounts && <th>Total Charges</th>}
                                {userPermissionViewAmounts && <th>Balance</th>}
                                <th>Patient Status</th>
                                {isTestCaseForLien(activeCase) && <th>
                                    Next Gen
                                </th>}
                                <th>Lien Created</th>
                                <th>Primary Clinic</th>
                                {isManagingAttorney(activeCase) && <th>{changeWordingForWC(activeCase, 'HIPAA', 'WC-207')}</th>}
                                {checkIfLopIsRequired(managingAttorney, activeCase)  && <th>LOP</th>}
                                <th>Records</th>
                                <th>Init Tx Day</th>
                            </tr>
                        </thead>
                        <tbody>
                            {practices.map((item, index) => (
                                <PracticeItem key={item.id} item={item} managingAttorney={managingAttorney} index={index} totalRows={practices.length} viewAmounts={userPermissionViewAmounts} editPermission={userPermissionEditStatus} />
                            ))}      
                        </tbody>
                        {userPermissionViewAmounts && <tfoot>
                            <tr>
                                <td colSpan={2}><strong>Totals</strong></td>
                                <td><strong>${formatCurrency(totals.totalCharges)}</strong></td>
                                <td><strong>${formatCurrency(totals.totalPracticeBalance)}</strong></td>
                                <td colSpan={8}></td>
                            </tr>
                        </tfoot>}
                    </table>
                </div>
            </Card>
            <AICAStatus />
        </>}
    </>
}

export default PracticeTable